<div class="image-cropper">
  <image-cropper [imageChangedEvent]="imageChangedEvent" [resizeToWidth]="resizeToWidth" [maintainAspectRatio]="true" [aspectRatio]="aspectRatio" (imageCropped)="imageCropped($event)"></image-cropper>
  <button class="image-ok" (click)="sendPhotoToServer()"><img src="/assets/images/ok.png"></button>
  <button class="image-cancel" (click)="cancel()"><img src="/assets/images/cancel.png"></button>
</div>